---
meta:
  - title: Clientes y expedientes - IUSPRO Docs
  - description: Entienda la diferencia entre clientes y expedientes para trabajar de forma más clara en IUSPRO.
---

# Clientes y expedientes

Esta es una de las dudas más normales al empezar:

**si puedo chatear desde un expediente y también desde un cliente, ¿cuál debo usar?**

La respuesta corta es esta:

- **expediente** = el caso o asunto jurídico
- **cliente** = el espacio de trabajo donde organiza varios chats y varias fuentes alrededor de ese cliente

## La forma más simple de entenderlo

Piense así:

- el expediente es la **fuente principal del caso**
- el cliente es la **mesa de trabajo**

En la mesa de trabajo usted puede poner:

- uno o varios expedientes
- archivos
- instrucciones
- varios chats sobre el mismo cliente

## Cuándo conviene chatear desde el expediente

Use el expediente cuando quiera una consulta directa y centrada en ese caso.

Por ejemplo:

- resumir el expediente
- entender los hechos
- revisar la cronología
- hacer una pregunta puntual sobre ese caso

Es la forma más rápida y enfocada.

## Cuándo conviene chatear desde el cliente

Use el cliente cuando el trabajo ya es más amplio.

Por ejemplo, cuando necesita:

- varios chats sobre el mismo cliente
- combinar expediente + archivos + instrucciones
- mantener contexto durante varios días
- separar estrategia, redacción y revisión en conversaciones distintas

Es la mejor opción para trabajo continuo.

## Entonces, ¿son competencia entre sí?

No. Lo ideal es verlos como dos niveles distintos:

- el expediente le da contexto sobre un caso concreto
- el cliente le ayuda a organizar el trabajo completo alrededor de ese cliente

En muchos casos, lo mejor será:

1. empezar con una consulta directa en el expediente
2. cuando el trabajo requiera continuidad, crear un cliente
3. vincular ese expediente al cliente
4. seguir trabajando desde el cliente

## Recomendación práctica

Si tiene que elegir una regla simple, use esta:

- **consulta rápida sobre un caso**: use el expediente
- **trabajo continuo con varios chats y materiales**: use el cliente

Así evita duplicar trabajo y entiende mejor dónde conviene avanzar.

## Siguiente lectura

- Lea [qué es un cliente](/guias/proyectos-que-es)
- Aprenda [cómo usar clientes](/guias/proyectos-como-usar)
- Si quiere trabajar directamente un caso, vea [análisis de expedientes](/guias/analisis-expedientes-como-usar)
